import { useQuery } from "react-query";
import { getCampaignDetails, getCampaigns } from "../../../services/campaign";
import { getGiftCardList } from "../../../services/giftcards";
import { getCustomerWallet } from "../../../services/sales-point";

export const useGetCampaigns = ({ queries = "", isEnabled = true }) => {
  return useQuery(
    ["getCampaigns", queries],
    () => getCampaigns(queries).then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetCampaignDetails = (id = "") => {
  return useQuery(
    ["getCampaignDetails", id],
    () => getCampaignDetails(id).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetGiftCards = ({ queries = "" }) => {
  return useQuery(
    ["getGiftCardList", queries],
    () => getGiftCardList(queries).then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetCustomerWallet = (customer_id) => {
  return useQuery(
    ["getCustomerWallet", [customer_id]],
    () => getCustomerWallet(customer_id).then((res) => res?.data?.data),
    { enabled: customer_id ? true : false },
  );
};
